"use client";

import urls from '@/utils/urls/urls';
import React from 'react'
import { Autoplay, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

export default function TestimonialsSlide({ testimonials }: { testimonials: any }) {
  // console.log("testimonials", testimonials)
  return (
    <>
      <Swiper
        className="mySwiper testimonial-slider owl-carousel owl-theme wow fadeInUp"
        data-wow-delay=".25s"
        slidesPerView={2}
        spaceBetween={30}
        modules={[Autoplay, Navigation]}
        navigation={{
          prevEl: ".destination-card2-prev",
          nextEl: ".destination-card2-next",
        }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        speed={1000}
        // breakpoints={{
        //     320: { slidesPerView: 1, spaceBetween: 10 },
        //     640: { slidesPerView: 2, spaceBetween: 20 },
        //     1024: { slidesPerView: 3, spaceBetween: 30 }
        // }}
        loop={true}
      >
        {
          testimonials?.map((testimonial: any) => (
            <SwiperSlide className="testimonial-item" key={testimonial?.id}>
              <div className="testimonial-quote">
                <div className="testimonial-rate">
                  <i className="fas fa-star" />
                  <i className="fas fa-star" />
                  <i className="fas fa-star" />
                  <i className="fas fa-star" />
                  <i className="fas fa-star" />
                </div>
                <div className="testimonial-quote-icon">
                  <img src="../assets/img/icon/quote.svg" alt="" />
                </div>
                {/* <div className="" style={{
                  // maxWidth: "300px",
                  height: "200px",
                  overflow: "hidden",
                  // whiteSpace: "nowrap",
                }}>
                  <p className="">
                    {testimonial?.message}
                  </p>
                </div> */}
                <div
                  className="position-relative"
                  style={{
                    height: "200px",
                    overflow: "hidden",
                    cursor: "pointer",
                  }}
                  title={testimonial?.message} // optional: shows full text on hover as tooltip
                >
                  <p
                    className="mb-0"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 8, // adjust number of lines
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.webkitLineClamp = "unset";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.webkitLineClamp = "8"; // same as default
                    }}
                  >
                    {testimonial?.message}
                  </p>
                </div>

              </div>
              <div className="testimonial-content">
                <div className="testimonial-author-img">
                  <img src={urls?.image + testimonial?.image} alt="" />
                </div>
                <div className="testimonial-author-info">
                  <h4>{testimonial?.name}</h4>
                  <p>Customer</p>
                </div>
              </div>
            </SwiperSlide>
          ))
        }
        {/* <SwiperSlide className="testimonial-item">
          <div className="testimonial-quote">
            <div className="testimonial-rate">
              <i className="fas fa-star" />
              <i className="fas fa-star" />
              <i className="fas fa-star" />
              <i className="fas fa-star" />
              <i className="fas fa-star" />
            </div>
            <div className="testimonial-quote-icon">
              <img src="../assets/img/icon/quote.svg" alt="" />
            </div>
            <p>
              Choosing TEX EXCELLENCE LIMITED has been one of our best decisions. Their advanced technology and exceptional customer service have significantly improved our manufacturing processes. Highly recommended.
            </p>
          </div>
          <div className="testimonial-content">
            <div className="testimonial-author-img">
              <img src="../assets/img/testimonial/01.jpg" alt="" />
            </div>
            <div className="testimonial-author-info">
              <h4>Niesha Phips</h4>
              <p>Customer</p>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="testimonial-item">
          <div className="testimonial-quote">
            <div className="testimonial-rate">
              <i className="fas fa-star" />
              <i className="fas fa-star" />
              <i className="fas fa-star" />
              <i className="fas fa-star" />
              <i className="fas fa-star" />
            </div>
            <div className="testimonial-quote-icon">
              <img src="../assets/img/icon/quote.svg" alt="" />
            </div>
            <p>
              Partnering with TEX EXCELLENCE has revolutionized our production. Their exceptional knitting machines and customer service have significantly improved our efficiency and quality. Highly recommended for innovation and reliability in textile manufacturing.
            </p>
          </div>
          <div className="testimonial-content">
            <div className="testimonial-author-img">
              <img src="../assets/img/testimonial/03.jpg" alt="" />
            </div>
            <div className="testimonial-author-info">
              <h4>Ebony Swihart</h4>
              <p>Customer</p>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="testimonial-item">
          <div className="testimonial-quote">
            <div className="testimonial-rate">
              <i className="fas fa-star" />
              <i className="fas fa-star" />
              <i className="fas fa-star" />
              <i className="fas fa-star" />
              <i className="fas fa-star" />
            </div>
            <div className="testimonial-quote-icon">
              <img src="../assets/img/icon/quote.svg" alt="" />
            </div>
            <p>
              TEX EXCELLENCE LIMITED has been instrumental in boosting our production quality. Their innovative knitting machines and responsive support team have been invaluable. We couldn't be happier with their service
            </p>
          </div>
          <div className="testimonial-content">
            <div className="testimonial-author-img">
              <img src="../assets/img/testimonial/02.jpg" alt="" />
            </div>
            <div className="testimonial-author-info">
              <h4>Daniel Porter</h4>
              <p>Customer</p>
            </div>
          </div>
        </SwiperSlide> */}
        {/* <div className="testimonial-item">
                      <div className="testimonial-quote">
                        <div className="testimonial-rate">
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                        </div>
                        <div className="testimonial-quote-icon">
                          <img src="../assets/img/icon/quote.svg" alt="" />
                        </div>
                        <p>
                          There are many variations passage available the majority
                          have suffered of alteration in some form by the injected
                          humour or randomised words which look even slightly
                          believable.
                        </p>
                      </div>
                      <div className="testimonial-content">
                        <div className="testimonial-author-img">
                          <img src="../assets/img/testimonial/03.jpg" alt="" />
                        </div>
                        <div className="testimonial-author-info">
                          <h4>Ebony Swihart</h4>
                          <p>Customer</p>
                        </div>
                      </div>
                    </div>
                    <div className="testimonial-item">
                      <div className="testimonial-quote">
                        <div className="testimonial-rate">
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                        </div>
                        <div className="testimonial-quote-icon">
                          <img src="../assets/img/icon/quote.svg" alt="" />
                        </div>
                        <p>
                          There are many variations passage available the majority
                          have suffered of alteration in some form by the injected
                          humour or randomised words which look even slightly
                          believable.
                        </p>
                      </div>
                      <div className="testimonial-content">
                        <div className="testimonial-author-img">
                          <img src="../assets/img/testimonial/04.jpg" alt="" />
                        </div>
                        <div className="testimonial-author-info">
                          <h4>Loreta Jones</h4>
                          <p>Customer</p>
                        </div>
                      </div>
                    </div> */}
      </Swiper>
    </>
  )
}
